
import {defineComponent} from "vue";
import AnimationChild from "@/components/AnimationBallAnimationChild.vue";

export default defineComponent({
  components: {AnimationChild},
  data() {
    return {
      isShowing: false,
      bkClass: 'bk',
      blurClass: 'blur'
    }
  },
  methods: {
    toggleShow() {
      this.isShowing = !this.isShowing;
    }
  }
})
